import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';

import {
  HeadingDisplay,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IInvestmentDetails } from '@/modules/transaction/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Preview',
  setup(__props) {

const fetchInvestment = inject('fetchInvestment', () => ({}));

const investmentDetails = inject(
  'investmentDetails'
) as Ref<IInvestmentDetails>;

const isFetchingInvestment = inject('isFetchingInvestment') as Ref<boolean>;
const amountFormatted = inject('amountFormatted') as Ref<string>;

const title = computed(() => {
  return `R$ ${amountFormatted.value}`;
});

function handleInvestment() {
  fetchInvestment();
}

return { __sfc: true,fetchInvestment, investmentDetails, isFetchingInvestment, amountFormatted, title, handleInvestment, HeadingDisplay, ListDisplay, ButtonContainer, ButtonPrimary }
}

})